import React from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Star, Check, X } from "lucide-react";

export default function AdminReviews() {
    const [items, setItems] = React.useState([]);
    const load = React.useCallback(() => api.get("/admin/reviews").then(r => setItems(r.data || [])), []);
    React.useEffect(() => { load(); }, [load]);

    const toggle = async (id, approved) => { await api.put(`/admin/reviews/${id}`, { approved }); toast.success("Actualizat"); load(); };
    const del = async (id) => {
        if (!window.confirm("Sigur ștergi?")) return;
        await api.delete(`/admin/reviews/${id}`);
        toast.success("Șters");
        load();
    };

    return (
        <div data-testid="admin-reviews">
            <div className="overline mb-2">Administrare</div>
            <h1 className="font-heading text-3xl uppercase mb-6">Recenzii</h1>
            <div className="space-y-3">
                {items.map((r, i) => (
                    <div key={r.review_id} className={`border-2 p-4 ${r.approved ? "border-primary" : "border-foreground"}`} data-testid={`review-${i}`}>
                        <div className="flex gap-1 text-primary mb-1">{[...Array(r.rating)].map((_, j) => <Star key={j} className="h-4 w-4 fill-current" />)}</div>
                        {r.title && <div className="font-heading">{r.title}</div>}
                        <p className="text-sm">{r.comment}</p>
                        <div className="text-xs font-mono text-muted-foreground mt-2">— {r.author_name} · {new Date(r.created_at).toLocaleString("ro-RO")}</div>
                        <div className="flex gap-2 mt-3">
                            <button onClick={() => toggle(r.review_id, !r.approved)} className={r.approved ? "btn-outline" : "btn-primary"}>{r.approved ? "Neafișează" : "Aprobă"}</button>
                            <button onClick={() => del(r.review_id)} className="btn-ghost text-destructive">Șterge</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
